/**
 * AdminAgentReleasesRpcClient — admin endpoints for the clawd
 * versioning model: list/promote/pause releases, pin install versions,
 * force-check updates, and read distribution + channel-history feeds.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminAgentReleasesRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminAgentReleasesRpcClient extends AtomRpc.Tag<AdminAgentReleasesRpcClient>()(
  "AdminAgentReleasesRpcClient",
  {
    group: AdminAgentReleasesRpcs,
    protocol: makeRpcClientLayer(AdminAgentReleasesRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
